<template>
    <TabLayout
        :title="Lang.get('employeedashboard::pages/settings/account.view_only.title')"
        :subtitle="Lang.get('employeedashboard::pages/settings/account.view_only.subtitle')"
        tabName="account"
    >

                <fieldset :disabled="true">
                    <div class="row">
                        <div class="form-group col-md-4">
                            <text-input
                                v-model="form.first_name"
                                :label="Lang.get('employeedashboard::shared.first_name')"
                                :placeholder="Lang.get('employeedashboard::shared.placeholder.first_name')"
                                :error="errors.first_name"
                                :isValidated="isValidated"
                            />
                        </div>
                        <div class="form-group col-md-4">
                            <text-input
                                v-model="form.middle_name"
                                :label="Lang.get('employeedashboard::shared.middle_name')"
                                :placeholder="Lang.get('employeedashboard::shared.placeholder.middle_name')"
                                :error="errors.middlename"
                            />
                        </div>
                        <div class="form-group col-md-4">
                            <text-input
                                v-model="form.last_name"
                                :label="Lang.get('employeedashboard::shared.last_name')"
                                :placeholder="Lang.get('employeedashboard::shared.placeholder.last_name')"
                                :error="errors.last_name"
                                :isValidated="isValidated"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-4">
                            <label class="font-poppins color-dark-blue">{{Lang.get('employeedashboard::shared.date_of_birth') }}</label>
                            <text-input
                                v-model="form.date_of_birth"
                                :placeholder="Lang.get('employeedashboard::shared.placeholder.date_of_birth')"
                                :disabled="true"
                            />
                        </div>
                        <div class="form-group col-md-4">
                            <label class="font-poppins color-dark-blue">{{Lang.get('employeedashboard::shared.birth_place')}}</label>
                            <text-input
                                v-model="form.birthplace"
                                :disabled="true"
                            />
                        </div>
                    </div>
                    <hr/>
                    <div class="row">
                        <div class="form-group col-md-12 d-flex justify-content-between">
                            <p>
                                {{ Lang.get('employeedashboard::shared.email') }}:
                                <span class="font-weight-semibold">{{ account.email }}</span>
                            </p>
                            <a :href="route('nl.employeedashboard.settings.primary-email.edit')" class="font-poppins ml-3 color-blue">
                                {{ Lang.get('employeedashboard::shared.edit') }}
                            </a>
                        </div>
                        <div class="col-md-12">
                            <div class="d-flex justify-content-between" v-if="recovery_email">
                                <p>
                                    {{ Lang.get('employeedashboard::shared.recovery_email') }}:
                                    <span class="font-weight-semibold">{{ recovery_email }}</span>
                                </p>
                                <a :href="route('nl.employeedashboard.settings.recovery-mail.edit')" class="font-poppins ml-3 color-blue">
                                    {{ Lang.get('employeedashboard::shared.edit') }}
                                </a>
                            </div>
                            <div v-else>
                                <a :href="route('nl.employeedashboard.settings.recovery-mail.create', { return_url: this.route('nl.employeedashboard.settings.account.show') })"
                                   class="font-poppins font-weight-light font-size-16 color-blue">
                                    {{ Lang.get('employeedashboard::shared.setup_recovery_email') }}
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div class="row">
                        <div class="form-group col-md-4">
                            <select-input
                                v-model="form.educational_level"
                                :label="Lang.get('generic.educational_attainment')"
                                :placeholder="Lang.get('generic.placeholder.educational_attainment')"
                                :error="errors.educational_level"
                                :isValidated="isValidated">
                                <option :value="null">{{ Lang.get('employeedashboard::shared.choose') }}</option>
                                <option v-for="(education, index) in educational_level_options" :value="index">
                                    {{ education }}
                                </option>
                            </select-input>
                        </div>
                        <div class="form-group col-md-4">
                            <text-input
                                v-model="form.function_description"
                                :label="Lang.get('employeedashboard::shared.function')"
                                :placeholder="Lang.get('employeedashboard::shared.placeholder.function')"
                                :error="errors.function_description"
                                :isValidated="isValidated"
                            />
                        </div>

                    </div>
                </fieldset>

                <div class="row">
                    <div class="form-group col-md-4">
                        <a :href="route('nl.employeedashboard.settings.account.edit')"
                            class="btn btn-primary btn-orange font-poppins font-weight-bold color-white border-radius-19 px-3 mt-3 mb-4">
                            {{ Lang.get('employeedashboard::shared.edit.button') }}
                        </a>
                    </div>
                </div>

    </TabLayout>
</template>

<script>
import TabLayout from "@/Pages/Settings/Shared/TabLayout";
import TextInput from "@/Shared/TextInput";
import FlashMessages from "@/Shared/FlashMessages";
import Checkbox from "@/Shared/Checkbox";
import FormError from "@/Shared/FormError";
import SelectInput from "@/Shared/SelectInput";

export default {
    metaInfo: { title: Lang.get('employeedashboard::pages/settings/account.title') },
    components: {
        TabLayout,
        FormError,
        Checkbox,
        TextInput,
        FlashMessages,
        SelectInput,
    },
    props: {
        errors: Object,
        account: Object,
        educational_level_options: Object,
        isValidated: Object,
        recovery_email: String,
    },
    data() {
        return {
            form: {
                date_of_birth: this.account.date_of_birth,
                birthplace: this.account.birthplace,
                remote_reference: this.account.remote_reference,
                first_name: this.account.first_name,
                middle_name: this.account.middle_name,
                last_name: this.account.last_name,
                email: this.account.email,
                current_password: '',
                function_description: this.account.function_description,
                educational_level: this.account.educational_level,
            },
        }
    },
    mounted() {
        const modalBackground = document.querySelector('.modal-backdrop');

        if (modalBackground) {
            modalBackground.remove();
        }
    }
}
</script>
